<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"  *ngIf="user.role === 'DRIVER'" ><a routerLink="/admin/driverDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Shipments</li>
    </ol>
  </nav>
  <div id="errorMessage2"class="invalid-feedback d-block" [hidden]="!errorMessage">{{errorMessage}}</div>
  <div class="row">
    <div class="col-8">
      <ul class="list-inline tab-list">
        <li class="list-inline-item"><a (click)="populateTabData('assigned'); getdriverShipmentLines('ASSIGNED');tabChange();" [ngClass]="{'active': tabClicked === 'assigned'}">Assigned</a></li>
        <li class="list-inline-item"><a (click)="populateTabData('pickUp'); getdriverShipmentLines('PICKED');tabChange();" [ngClass]="{'active': tabClicked === 'pickUp'}">In Transit</a></li>
        <li class="list-inline-item"><a (click)="populateTabData('delivered'); getdriverShipmentLines('DELIVERED');tabChange();" [ngClass]="{'active': tabClicked === 'delivered'}">Delivered</a></li>
      </ul>
    </div>
    <div class="col-4 text-right" [hidden]="tabClicked === 'delivered'">
      <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn btn-outline-primary btn-sm dropdown-toggle d-none-mobile" [disabled]="(!checkedList?.length)">
        Actions
      </button>
      <div class="dropdown-menu dropdown-menu2  dropdown-menu-right">
        <a  *ngIf="tabClicked === 'assigned'" (click)="checkShipLines(shipList)" class="dropdown-item file btn shift-import">Pick Up</a>
        <a  *ngIf="tabClicked === 'pickUp'" (click)="checkShipDeliver(shipList)" class="dropdown-item file btn shift-import">Deliver</a>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="inner-box d-none d-sm-block">
          <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
            <thead>
            <tr>
              <th><div class="form-checkbox">
                <input type="checkbox" id="all_items" [(ngModel)]="masterSelected" name="list_name" value="m1" (change)="checkUncheckAll()"/>
                <label for="all_items"></label>
              </div></th>
              <th>Shipment Number</th>
              <th>PickUp Location</th>
              <th>Destination Location</th>
              <th>Creation Date</th>
              <th>Label</th>
              <th>Status</th>
            </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sp of shipList">
                <td><div class="form-checkbox"><input type="checkbox" id="{{sp.id}}" [(ngModel)]="sp.isSelected" name="list_name" (change)="selectShip(sp)"><label for="{{sp.id}}"></label></div></td>
                <td><a class="ml-2" routerLink="/admin/viewShipment/{{sp.id}}">{{sp.id}}</a></td>
                <td>{{sp.accountOwnerAddress}}</td>
                <td>{{sp.addressText}}</td>
                <td>{{sp.createdDate}}</td>
                <td>
                  <a (click)="getShipmentLineDetail(sp)" id="modalActivateAO" data-toggle="modal" href="#exampleModalPreview">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21.54" height="21.54" viewBox="0 0 21.54 21.54"><defs><style>.a{fill:#ee7125;}</style></defs><path class="a" d="M23.8,4.5H6.744A2.244,2.244,0,0,0,4.5,6.744V23.8A2.244,2.244,0,0,0,6.744,26.04H23.8A2.244,2.244,0,0,0,26.04,23.8V6.744A2.244,2.244,0,0,0,23.8,4.5ZM17.963,21.553H8.988V18.86h8.975Zm3.59-4.936H8.988V13.924H21.553Zm0-4.936H8.988V8.988H21.553Z" transform="translate(-4.5 -4.5)"/></svg>
                  </a>
                </td>
                <td>{{(sp.status == 'ASSIGNED' ? 'Assigned' : (sp.status == 'PICKED' ? 'Picked' : (sp.status == 'DELIVERED' ? 'Delivered' : (sp.status))))}}</td>
              </tr>
            </tbody>
          </table>
      </div>
      <div class="inner-box d-block d-sm-none">
        <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack" >
          <thead>
          <tr>
            <th>Shipment Number</th>
            <th>PickUp Location</th>
            <th>Destination Location</th>
            <th>Creation Date</th>
            <th>Label</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let sp of shipList">
            <td><b class=" tablesaw-cell-label">Shipment Number</b>
              <span class="tablesaw-cell-content"><a class="ml-2" routerLink="/admin/viewShipment/{{sp.id}}">{{sp.id}}</a></span></td>
            <td><b class=" tablesaw-cell-label">PickUp Location</b>
              <span class="tablesaw-cell-content">{{sp.accountOwnerAddress}}</span></td>
            <td><b class=" tablesaw-cell-label">Destination Location</b>
              <span class="tablesaw-cell-content">{{sp.addressText}}</span></td>
            <td><b class=" tablesaw-cell-label">Creation Date</b>
              <span class="tablesaw-cell-content">{{sp.createdDate}}</span></td>
            <td><b class=" tablesaw-cell-label">Lable</b>
              <span class="tablesaw-cell-content">
              <a (click)="getShipmentLineDetail(sp)" id="modalActivateAO" data-toggle="modal" href="#exampleModalPreview">
                <svg xmlns="http://www.w3.org/2000/svg" width="21.54" height="21.54" viewBox="0 0 21.54 21.54"><defs><style>.a{fill:#ee7125;}</style></defs><path class="a" d="M23.8,4.5H6.744A2.244,2.244,0,0,0,4.5,6.744V23.8A2.244,2.244,0,0,0,6.744,26.04H23.8A2.244,2.244,0,0,0,26.04,23.8V6.744A2.244,2.244,0,0,0,23.8,4.5ZM17.963,21.553H8.988V18.86h8.975Zm3.59-4.936H8.988V13.924H21.553Zm0-4.936H8.988V8.988H21.553Z" transform="translate(-4.5 -4.5)"/></svg>
              </a>
              </span></td>
            <td>
              <b class=" tablesaw-cell-label">Status</b>
              <span class="tablesaw-cell-content">
                {{(sp.status == 'ASSIGNED' ? 'Assigned' : (sp.status == 'PICKED' ? 'Picked' : (sp.status == 'DELIVERED' ? 'Delivered' : (sp.status))))}}</span></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>

<div class="modal fade right" id="exampleModalPreview" tabindex="-1" role="dialog" aria-labelledby="exampleModalPreviewLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog-45 modal-fluid modal-dialog-scrollable" role="document">
    <div class="snk-modal-content modal-content">
      <div class="snk-modal-header modal-header text-center">
        <h5 class="modal-title w-100" id="exampleModalPreviewLabel">Shipping label</h5>
        <button type="button" class="close " data-dismiss="modal" aria-label="Close">
          <span style="font-size: 1.3em;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>

          <div class="row mt-3">
            <div class="col-md-12 text-right">
              <button class="btn btn-cancel" type="button" data-dismiss="modal" aria-label="Close">Close</button>
              <button type="submit" class="btn btn-orange ml-2" (click)="generatePdf()">Print</button>
            </div>
          </div>

          <div *ngFor="let n of noOfBoxesArray">
            <div class="row mt-3">
              <div class="col">
                <div class="inner-box">


                  <div class="row">


                    <div class="col-md-2">
                      <img class="shift-uploaded-img shift-image" src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}" width="250" height="200"/>
                    </div>

                    <div class="col-md-6">
                      <h2 class="text-body mb-3"><b>From:</b></h2>
                      <label class="text-body"><b>{{modalShipmentLine.accountOwnerName}}</b></label><br>
                      <label class="text-body"><b>{{modalShipmentLine.accountOwnerAddress}}</b></label><br>
                      <hr class="border border-dark">
                      <h2 class="text-body mb-3"><b>To:</b></h2>
                      <label class="text-body"><b>{{modalShipmentLine.accountOwnerContactName}}</b></label><br>
                      <label class="text-body"><b>{{modalShipmentLine.addressText}}</b></label>

                    </div>
                    <div class="col-md-2 text-dark-right">
                      <qrcode [qrdata]="myAngularxQrCode" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
                    </div>
                  </div>



                  <div class="row">
                    <div class="col-md-12">
                      <h2 class="text-black mb-3">Box Details</h2>
                    </div>
                  </div>

                  <table class="table">
                    <tr>
                      <th>Box#</th>
                      <th>No. of Boxes</th>
                      <th>W x L x H</th>
                      <th>Weight</th>
                    </tr>
                    <tr>
                      <td>{{n}} of {{modalShipmentLine.noOfBoxes}}</td>
                      <td>{{modalShipmentLine.noOfBoxes}}</td>
                      <td>{{modalShipmentLine.width}} x {{modalShipmentLine.length}} x {{modalShipmentLine.height}}</td>
                      <td>{{modalShipmentLine.weight}}</td>
                    </tr>
                  </table>

                  <!--
                                  <div class="row">
                                    <div class="col-md-3">
                                      <label><b>Weight :</b> {{modalShipmentLine.weight}}</label><br>
                                      <label><b>NoOfBoxes :</b> {{modalShipmentLine.noOfBoxes}}</label><br>
                                    </div>
                                    <div class="col-md-3">
                                      <label><b>Width :</b> {{modalShipmentLine.width}}</label><br>
                                      <label><b>Box#:</b>Box-{{n}}</label><br>
                                    </div>
                                    <div class="col-md-3">
                                      <label><b>Length :</b> {{modalShipmentLine.length}}</label><br>
                                    </div>
                                    <div class="col-md-3">
                                      <label><b>Height :</b> {{modalShipmentLine.height}}</label><br>
                                      &lt;!&ndash;<label><b>Size :</b> {{modalShipmentLine.boxSize}}</label><br> &ndash;&gt;
                                    </div>
                                    </div>
                  -->

                </div>
              </div>
            </div>
          </div>
<!--          <div class="row mt-3">
            <div class="col-md-12 text-right">
              <button class="btn btn-cancel" type="button" data-dismiss="modal" aria-label="Close">Close</button>
              <button type="submit" class="btn btn-orange ml-2" (click)="print()">Print</button>
            </div>
          </div>-->

        </form>
      </div>
    </div>
  </div>
</div>


<div  [ngStyle]="{'display': driverDetails =='Y'? 'block' : 'none'}" style="overflow-y:auto"  [ngClass]="{'modal': driverDetails == 'Y'}" class="modal" id="driverDetails" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleDriverModalPreviewLabel">Pick Up label</h5>
        <div id="errorMessage"class="invalid-feedback d-block" [hidden]="!errorMessage">{{errorMessage}}</div>
        <button type="button" class="close" (click)="cancelDriver()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none" stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none" stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
              <div class="inner-box">
                <div class="col">
                  <label class="control-label" for="shipmentNumber">Shipment Unique Number</label>
                  <input type="text" id="shipmentNumber" class="form-control" [(ngModel)]="shipmentNumber" [ngModelOptions]="{standalone: true}" required>
                </div>
                <div id="statusText1" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText1">{{statusText1}}</div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 text-right">
              <button class="btn btn-cancel" type="button" (click)="clearDriver()" aria-label="Close">Clear</button>
              <button type="submit" class="btn btn-orange ml-1" (click)="submitDriverStatus()">Submit</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div [ngStyle]="{'display': delivereDriverDetails =='Y'? 'block' : 'none'}" style="overflow-y:auto"  [ngClass]="{'modal': delivereDriverDetails == 'Y'}" class="modal" id="driverDetails" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="deliverExampleModalPreviewLabel">OTP to Submit Delivery</h5>
        <button type="button" class="close" (click)="cancelDriverDetails()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none" stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none" stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
                    <form>
                      <div class="invalid-feedback d-block mb-3" [hidden]="!errorMessage">{{errorMessage}}</div>
<!--                      <div class="text-success invalid-feedback d-block mb-3" [hidden]="!successMessage">{{successMessage}}</div>-->
                      <p class="mt-5">
                        Enter 4 digit pin sent to Customer Mobile</p>
                      <div class="row">
                        <div class="col-2"><input type="text" (keyup)="keytab($event, 'password2', 'password1')"  id="password1" [(ngModel)]="password1"  class="form-control text-center" maxlength="1"  [ngModelOptions]="{standalone: true}" required></div>
                        <div class="col-2"><input type="text" (keyup)="keytab($event, 'password3', 'password1')" id="password2" [(ngModel)]="password2"  class="form-control text-center" maxlength="1"  [ngModelOptions]="{standalone: true}" required></div>
                        <div class="col-2"><input type="text" (keyup)="keytab($event, 'password4', 'password2')" id="password3" [(ngModel)]="password3"  class="form-control text-center" maxlength="1"  [ngModelOptions]="{standalone: true}" required></div>
                        <div class="col-2"><input type="text" (keyup)="keytab($event, 'password4', 'password3')" id="password4" [(ngModel)]="password4"  class="form-control text-center" maxlength="1"  [ngModelOptions]="{standalone: true}" required></div>
                      </div>
                      <div class="row align-items-center mb-4 mt-4">
                        <div class="col-md-12 text-center">
                          <a (click)="submitResend()">Resend OTP</a>
                        </div>
                      </div>
                    </form>
              <div class="row mt-2">
                <div class="col-md-12 text-right">
                  <button class="btn btn-cancel" type="button" (click)="clearDriverDetails()" aria-label="Close">Clear</button>
                  <button type="submit" class="btn btn-orange ml-1" (click)="otpSubmit()">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
